import { connect } from 'react-redux/es';
import NoResults from '../NoResults';
import { byNoResults } from '../../modules/resultList';

const mapStateToProps = (state: any) => ({
  noHits: byNoResults(state),
});

export default connect(mapStateToProps)(NoResults);
